import React, { useState, useEffect, useRef } from 'react'
import { Card, Col, Container, NavLink, Nav, NavItem, TabContent, TabPane } from 'reactstrap'
// actions
import { addNewUser, updateUser, updateUserStatus, getOperatives, getTechAdvisors } from "../../../store/catalogs/Users/actions"
import { getLocations } from "../../../store/catalogs/Locations/actions"
import { getLabTypes } from "../../../store/catalogs/LabTypes/actions"
import { useSelector, useDispatch } from "react-redux";

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import classnames from 'classnames';
import { UserRegisterModal } from './UserRegisterModal'
import { ToastContainer } from 'react-toastify'
import { BaseCustomButton } from '../../../shared'
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

export const CatalogLayoutLabStaffs = (props) => {

    const [activeTab, setActiveTab] = useState('1');
    const activeTabRef = useRef(activeTab); // Reference to store the latest activeTab value (garanteed to be the latest value in an event handler)

    const profiletoggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const [showModal, setShowModal] = useState(false);

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [searchData, setSearchData] = useState('');
    const [isAdvisor, setIsAdvisor] = useState(false);
    const [isEditingOwnAccount, setIsEditingOwnAccount] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (activeTab === '1') {
            dispatch(getOperatives(`?limit=20&page=0&userType=Operativo`))
        } else {
            dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico`))
        }
    }, [activeTab])

    useEffect(() => {
        if (activeTab === '1') {
            dispatch(getOperatives(`?limit=20&page=0&userType=Operativo&search=${searchData}`))
        } else {
            dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico&search=${searchData}`))
        }
    }, [searchData])

    useEffect(() => {
        activeTabRef.current = activeTab; // Update ref whenever activeTab changes
    }, [activeTab]);

    // * Redux
    useEffect(() => {
        dispatch(getLocations(`?limit=100&page=0&`))
        dispatch(getLabTypes(`?limit=100&page=0`))
        dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico`))
        dispatch(getOperatives(`?limit=20&page=0&userType=Operativo`))
    }, [dispatch])

    const {
        loading,
        locations,
        labtypes,
        techAdvisors,
        operatives,
        totalOperatives,
        currentPageOperatives,
        totalTechAdvisors,
        currentPageTechAdvisors
    } = useSelector(state => ({
        users: state.usersReducer.users,
        loading: state.usersReducer.loading,
        user: state.usersReducer.user,
        total: state.usersReducer.total,
        currentPage: state.usersReducer.currentPage,
        advisers: state.technicalAdvisers.technicalAdvisers,
        adviserLoading: state.technicalAdvisers.loading,
        adviser: state.technicalAdvisers.technicalAdviser,
        adviserTotal: state.technicalAdvisers.total,
        adviserCurrentPage: state.technicalAdvisers.currentPage,
        locations: state.locations.locations,
        labtypes: state.labType.labtypes,
        techAdvisors: state.usersReducer.techAdvisors,
        operatives: state.usersReducer.operatives,
        totalOperatives: state.usersReducer.totalOperatives,
        currentPageOperatives: state.usersReducer.currentPageOperatives,
        totalTechAdvisors: state.usersReducer.totalTechAdvisors,
        currentPageTechAdvisors: state.usersReducer.currentPageTechAdvisors,
    }));
    // * Redux fin

    const getCurrentUserID = () => {
        try {
            const storedUser = localStorage.getItem("authUser");
            if (!storedUser) {
                console.warn("No se encontró información de usuario en localStorage.");
                return null;
            }
    
            const authUser = JSON.parse(storedUser);
            if (!authUser || typeof authUser !== "object") {
                console.error("Datos de usuario inválidos en localStorage.");
                return null;
            }
    
            return authUser.id ?? null;
        } catch (error) {
            console.error("Error al obtener el ID del usuario:", error);
            return null;
        }
    };    

    const getCurrentTab = () => activeTabRef.current;

    const onUpdate = (values) => {
        if (getCurrentTab() === '2') {
            setIsAdvisor(true);
        }
        if (getCurrentUserID() === values.id) {
            setIsEditingOwnAccount(true);
        }
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal(true)
    }

    const onToggleStatus = (values) => {
        try {
            const currentUserId = getCurrentUserID();
            // Prevent user from deactivating their own account
            if (values.id === currentUserId) {
                toast.error("Error: no puedes desactivar tu propia cuenta.");
                return;
            }
            // Proceed with status update
            dispatch(updateUserStatus({
                id: values.id,
                recordStatus: !values.recordStatus,
            }));
            toast.success("Estatus actualizado correctamente");
    
            setTimeout(() => {
                if (getCurrentTab() === '2') {
                    dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico`));
                } else {
                    dispatch(getOperatives(`?limit=20&page=0&userType=Operativo`));
                }
            }, 700);
        } catch (error) {
            toast.error("Error al actualizar el estatus.");
        }
    };

    const showTechAdvisorRegisterModal = () => {
        setIsAdvisor(true)
        setShowModal(true)
    }

    const showOperativeRegisterModal = () => {
        setIsAdvisor(false)
        setShowModal(true)
    }

    const getPagination = (params) => {
        if (activeTab === '1') {
            dispatch(getOperatives(`${params}&userType=Operativo&search=${searchData}`))
        } else {
            dispatch(getTechAdvisors(`${params}&userType=Asesor Técnico&search=${searchData}`))
        }
    }

    const RegisterModalRespInfo = (values, active) => {
        let statusChanged = false;
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateUser(updValue))
            if (active !== rowInfo.recordStatus) {
                statusChanged = true;
                setTimeout(() => {
                    dispatch(updateUserStatus({
                        id: rowInfo.id,
                        recordStatus: active,
                    }));
                }, 300);
            }
        } else {
            dispatch(addNewUser(values))
        }
        setTimeout(() => {
            if (isAdvisor) {
                dispatch(getTechAdvisors(`?limit=20&page=0&userType=Asesor Técnico`))
                setIsAdvisor(false)
            } else {
                dispatch(getOperatives(`?limit=20&page=0&userType=Operativo`))
            }
        }, statusChanged ? 1200 : 700);
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsEditingOwnAccount(false)
        setIsUpdate(false)
        setIsAdvisor(false)
    }

    const columns = React.useMemo(() => [
        {
            Header: 'Nombre',
            minWidth: '14%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.name ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Apellido',
            minWidth: '14%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.surname ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'E-mail',
            minWidth: '10%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.email ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Dirección',
            minWidth: '15%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.address ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Número teléfono',
            minWidth: '12%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.phone ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Rol de usuario',
            minWidth: '9%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.role ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Tipo de Usuario',
            minWidth: '12%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.userType ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Ubicación',
            minWidth: '12%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.location?.name ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Tipo de Laboratorio',
            minWidth: '12%',
            Cell: ({ row }) => (
                <div>
                    <div className='text-left'>{row.original.laboratoryType?.name ?? '-'}</div>
                </div>
            ),
        },
        {
            Header: 'Estatus',
            minWidth: "8%",
            Cell: ({ row }) => (
                row.original.recordStatus == true ?
                    <div className='text-success'>Activo</div> :
                    <div className='text-danger'>Inactivo</div>
            ),
        },
        {
            minWidth: '100px',
            Header: "Acciones",
            Cell: ({ row }) => (
                <div className="page-title-box d-flex align-items-center justify-content-center row">
                    <BaseCustomButton
                        color='primary'
                        outline
                        className="col-10 mb-2 p-1"
                        icon="mdi-lead-pencil mdi-18px"
                        label="Editar"
                        onClick={() => onUpdate(row.original)}
                    />
                    <BaseCustomButton
                        color={row.original.recordStatus == true ? 'danger' : 'success'}
                        outline
                        className="col-10 p-1"
                        icon={`mdi-18px d-flex align-items-center justify-content-center ${row.original.recordStatus == true ? 'mdi-close-circle' : 'mdi-check-circle'}`}
                        label={row.original.recordStatus == true ? "Desactivar" : "Activar"}
                        style={{ textWrap: 'nowrap' }}
                        onClick={() => onToggleStatus(row.original)}
                    />
                </div>
            ),
        },
    ], [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>
                            <div>
                                <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='LabStaffsCatalog' />
                            </div>
                            <Card className='' style={{ padding: 20 }}>
                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { profiletoggle('1'); }}>
                                            Personal Operativo</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ cursor: "pointer" }}
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { profiletoggle('2'); }}>Asesor Técnico</NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-4">

                                    <TabPane tabId="1">
                                        <div>
                                            <div className='pe-1'>
                                                <BackButton props={props} />
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                                    <SearchBar setSearchData={setSearchData} />
                                                </div>
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                                    <NewRegisterButton setShowModal={showOperativeRegisterModal} showModal={showModal} />
                                                </div>
                                            </div>

                                            <div className='ms-1'>
                                                <Table1
                                                    currentPage={currentPageOperatives}
                                                    getPagination={getPagination}
                                                    total={totalOperatives}
                                                    loading={loading}
                                                    isAddTableBorderStrap
                                                    columns={columns}
                                                    data={operatives}
                                                />
                                            </div>
                                            <br />
                                        </div>
                                    </TabPane>

                                    <TabPane tabId="2">
                                        <div className='pe-1'>
                                            <BackButton props={props} />
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                                <SearchBar setSearchData={setSearchData} />
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                                <NewRegisterButton setShowModal={showTechAdvisorRegisterModal} showModal={showModal} />
                                            </div>
                                        </div>

                                        <div className='ms-1'>
                                            <Table1
                                                currentPage={currentPageTechAdvisors}
                                                getPagination={getPagination}
                                                total={totalTechAdvisors}
                                                loading={loading}
                                                isAddTableBorderStrap
                                                columns={columns}
                                                data={techAdvisors}
                                            />
                                        </div>
                                    </TabPane>

                                </TabContent>
                            </Card>
                            <br />
                            <br />
                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>

            <UserRegisterModal
                labtypes={labtypes}
                locations={locations}
                rowInfo={rowInfo}
                modalClose={modalClose}
                isUpdate={isUpdate}
                isAdvisor={isAdvisor}
                modalRespInfo={RegisterModalRespInfo}
                setShowModal={setShowModal}
                showModal={showModal}
                isEditingOwnAccount={isEditingOwnAccount}
            />

        </React.Fragment>
    )
}
